import axios from "axios";

export default {
    
    namespaced: true,

    state: {
        myWatchlists: [],
        currentWatchlist: {},
        sortingType1: [
            { value: 'DESC', text: 'Z-A'},
            { value: 'ASC', text: 'A-Z'},
        ],
        sortingType2: [
            { value: 'DESC', text: 'High to Low'},
            { value: 'ASC', text: 'Low to high'},
        ],
        sortDir1: "DESC",
        sortDir2: "DESC",
        order1: {},
        order2: {},
        searchData: [],
        showSecondOption: false,
    },
    getters: {},
    actions: {
        async getMyWatchlists({commit}) {
            await axios.get("/watchlist")
                .then(res => {
                    commit("SET_MY_WATCHLISTS", res.data.data);
                })
        },
    },
    mutations: {
        SET_MY_WATCHLISTS(state, value) {
            state.myWatchlists = value;
        },
        SET_CURRENT_WATCHLIST(state, watchlist) {
            state.currentWatchlist = watchlist; 
        },
        SET_SORTING1(state, value) {
            state.order1 = value
        },
        SET_SORTING2(state, value) {
            state.order2 = value
        },
        SET_SORTING_TYPE1(state, value) {
            state.sortingType1 = value
        },
        SET_SORTING_TYPE2(state, value) {
            state.sortingType2 = value
        },
        SET_SORT_DIR1(state, value) {
            state.sortDir1 = value
        },
        SET_SORT_DIR2(state, value) {
            state.sortDir2 = value
        },
        SET_SEARCH_WATCHLIST(state, value) {
            state.searchData = value
        },
        SHOW_SECOND_OPTION(state, value) {
            state.showSecondOption = value
        }
    }
}


